import { useAuthContext } from '@/features/auth/context'
import { EValveType } from '@/features/config/components/sidebar/HydraulicRule/FormValveView/constant'
import useSearchFlowRuleId from '@/features/config/hooks/hydraulic/flowRule/useSearchFlowRuleId'
import useTranslation from '@/hooks/useTranslation'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

const CustomSingleFlowValue = (props: any) => {
  const { data, innerRef, innerProps } = props
  const { interfaceId } = useAuthContext()
  const { t } = useTranslation()
  const { data: dataRuleDetail } = useSearchFlowRuleId(
    Number(interfaceId||0),
    Number(data?.flowRuleId),
  )

  const themeMode = useSelector(selectTheme)

  const isDarkMode = themeMode === mode_type.dark

  return data ? (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        width: '100%',
        padding: '0 15px 20px 0',
        // background: isDarkMode ? '#333' : '#f5f5f5',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('formsLabelsPipe')}:</strong> {dataRuleDetail?.pipeName}
      </Typography>

      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('flowValveType')}:</strong> {EValveType[data.type]}
      </Typography>

      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('ioName')}</strong> {data.io}
      </Typography>

      <Typography variant="body2">
        <strong>{t('ioAddress')}</strong> {data.address}
      </Typography>
    </Box>
  ) : null
}
export default CustomSingleFlowValue
